<mat-chip-list aria-label="Absence Codes">
  <mat-chip *ngFor="let absenceCode of absenceCodesData">{{
    absenceCode.abs_code
  }}</mat-chip>
</mat-chip-list>
